const WORK_START_HOUR = 8;
const WORK_END_HOUR = 17;

function isBusinessDay(date) {
  const day = date.getDay();
  return day >= 1 && day <= 5;
}

function startOfBusinessDay(date) {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    WORK_START_HOUR,
    0,
    0,
    0
  );
}

function endOfBusinessDay(date) {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    WORK_END_HOUR,
    0,
    0,
    0
  );
}

export function businessMillisBetween(startMs, endMs) {
  if (!Number.isFinite(startMs) || !Number.isFinite(endMs) || endMs <= startMs) return 0;
  let total = 0;
  let cursor = new Date(startMs);
  const end = new Date(endMs);

  while (cursor < end) {
    if (isBusinessDay(cursor)) {
      const dayStart = startOfBusinessDay(cursor);
      const dayEnd = endOfBusinessDay(cursor);
      const segStart = new Date(Math.max(cursor.getTime(), dayStart.getTime()));
      const segEnd = new Date(Math.min(end.getTime(), dayEnd.getTime()));
      if (segEnd > segStart) {
        total += segEnd.getTime() - segStart.getTime();
      }
    }
    cursor = new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate() + 1, 0, 0, 0, 0);
  }

  return total;
}

export function hasBusinessHoursElapsed(startMs, endMs, requiredHours) {
  const required = Number(requiredHours) * 60 * 60 * 1000;
  if (!Number.isFinite(required) || required <= 0) return false;
  return businessMillisBetween(startMs, endMs) >= required;
}
